import {
  DEFAULT_ERROR_MODAL_TITLE,
  quickCodeLookupFailurePlainText,
} from '@buxus/shared'
import { showAppErrorModal } from '../platform/ui/appErrorModal'
import { hasNativeHostBridge } from '../platform/shell/nativeHostBridge'
import { QuickCodeLookupErrorBody } from './QuickCodeLookupErrorBody'

/** Invalid / missing Quick Code lookup (legacy mobile `QuickCodeForm` modal). */
export function showQuickCodeLookupErrorModal(): void {
  showAppErrorModal({
    title: DEFAULT_ERROR_MODAL_TITLE,
    message: quickCodeLookupFailurePlainText(),
    messageNode: hasNativeHostBridge() ? undefined : <QuickCodeLookupErrorBody />,
  })
}
